import usePermission from '../../../hook/usePermission'
import {useAppSelector} from '../../../redux/useTypedSelector'
import {Pagination} from '../../../utils/pagination'
import {DailySoldReportContext} from '../context'
import useGetAllMappedUsers from '../hooks/useGetAllMappedUsers'
import {useGetDailySoldReport} from '../hooks/useGetDailySoldReport'
import {useGetDashboardFilters} from '../hooks/useGetDashboardFilters'
import useGetProductTags from '../hooks/useGetProductTags'
import DailySoldReportHeader from '../sections/headers/DailySoldReportHeader'
import DailySoldReportTable from '../sections/table/DailySoldReportTable'

const DailySoldReport = () => {
  const {hasPermission} = usePermission()

  const {
    replenishment,
    isFetchingReplenishmentData,
    pagination,
    filters,
    onSearch,
    onPageChange,
    onClickSorting,
    onApplyFilters,
    register,
    selectedSkus,
    onDownloadCsv,
    isFetchingCsvData,
    monthly_column,
    isLoadingCsv,
    onCsvExport,
  } = useGetDailySoldReport()
  const {tableFilters, handleUserChange, onChangeDiscontinueFilters, onResetDropdownFilters} =
    useGetDashboardFilters()
  const {mappedUsers, isFetchingData} = useGetAllMappedUsers()
  const {tags} = useGetProductTags()
  const {user} = useAppSelector((state) => state.auth)
  const isUserExist = user?.is_owner
    ? false
    : JSON.parse(localStorage.getItem('is_supplier') || 'false')

  const hasWritePermission = hasPermission('analytics_replenishment_dashboard', 'write')

  const contextValues = {
    hasWritePermission,
    handleUserChange,
    onResetDropdownFilters,
    replenishment,
    isFetchingReplenishmentData,
    onSearch,
    onApplyFilters,
    selectedSkus,
    tags,
    mappedUsers,
    isFetchingData,
    onDownloadCsv,
    isFetchingCsvData,
    tableFilters,
    onChangeDiscontinueFilters,
    filters,
    onClickSorting,
    register,
    monthly_column,
    isUserExist,
    isLoadingCsv,
    onCsvExport,
  }

  return (
    <DailySoldReportContext.Provider value={contextValues}>
      <DailySoldReportHeader />
      <DailySoldReportTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </DailySoldReportContext.Provider>
  )
}

export default DailySoldReport
